<template>
  <bvue-ui-view :scroll="true">
    <div class="w-full">
      <button @click="$router.go(-1); $store.commit('bigMap')" class="link flex items-center mb-8">
         <i class="material-icons">arrow_back</i>
         <label>{{ $t('volver') }}</label>
      </button>
    </div>
    <!-- Header -->
    <div class="treeHeader">
      <div class="flex items-top w-full">
        <img src="data:image/svg+xml;base64,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" class="tree-icon">
        <div class="flex-1 flex flex-col ml-2 truncate">
          <div class="flex">
            <label class="specieName bold truncate">
                {{specie.name}}
            </label>
            <!-- IF planted: User -->
            <!-- <div v-if="planted" class="flex-1 justify-end flex flex-col treeHeaderDetails">
              <div class="flex justify-end">
                <div class="avatarBack">
                    <img :src="avatar(owner)" class="miniAvatar">
                </div>
                <label class="ownerName truncate">Por {{owner.name}}</label>
              </div>
            </div> -->
          </div>
          <div class="sm:flex">
            <div class="flex-col flex-1">
               <label class="scientificName truncate">{{specie.scientificName}}</label>
               <label class="plantLoc truncate">{{tree.position.lat.toFixed(8)}}, {{tree.position.lat.toFixed(8)}}</label>
            </div>
            <!-- IF planted: Co2 -->
            <!-- <div v-if="planted" class="flex sm:justify-end">
              <div class="flex chip infoChip mt-2 items-center">
                <label class="chipLabel truncate">CO2 Neutralizado</label>
                <div class="flex-1 justify-end flex">
                  <div class="flex justify-end truncate">
                    <label>{{neutralizedCO2}} mmHg</label>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- IF not planted: CTA -->
            <div v-if="!profile && !planted">
              <button id="registroarbol" class="btn btn-primary mr-3 mb-4" @click="plant">{{ $t('registrate') }}</button>
            </div>
            <div class="button-placeholder" v-if="profile && !planted">
              <button class="btn btn-primary" @click="plant">{{ $t('plantar') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- IF planted: User comment-->
    <div v-if="planted && owner" class="mt-4 cursor-pointer" @click="showOwnerProfile">
      <label class="block grey-text text-xs">{{ $t('plantadoel') }} {{formattedDate(planted.date)}}</label>
      <div class="md:flex">
        <div class="flex items-center mr-4 mt-2 pr-4 mb-2">
          <div class="flex items-top">
            <img :src="avatar(owner)" class="avatar">
            <div class="flex-1 flex flex-col ml-2 labels mt-2">
              <label class="flex-1 text-sm userName">{{owner.name}}</label>
              <label class="flex-1 text-xs userTrees">{{ownerTrees}} {{ownerTrees == 1 ? 'árbol' : 'árboles'}}</label>
            </div>
          </div> 
          <div  class="link flex items-center ml-4">
            <label>{{ $t('verperfil') }}
            </label>
             <i class="icon icon-arrow-right arrow ml-2"></i>
          </div>
        </div>
        <!-- Message in tree v2.0 -->
        <!-- <div class="blockquote flex-1 my-1">
          <label class="block almost-black-text text-xs">"{{planted.message}}"</label>
        </div> -->
      </div>
    </div>
    <!-- IF planted: Crecimiento -->
    <!-- <div v-if="planted" class="w-full mt-4">
      <label class="flex grey-text text-xs mb-2">DATOS DE CRECIMIENTO</label>
      <div class="md:flex">
        <div class="w-full md:w-1/2 greyBox md:mr-1 mb-2 py-8">
        <label class="grey-text text-xs mr-2">ALTURA: </label>
        <label class="base-text bold">1,97cm</label> <label class="grey-text">+ 0,47cm</label>
        </div>
        <div class="w-full md:w-1/2 greyBox md:ml-1 mb-2 py-8">
        <label class="grey-text text-xs mr-2">GROSOR:</label>
        <label class="base-text bold">0,47cm</label> <label class="grey-text">+ 0,17cm</label>
        </div>
      </div>
    </div> -->
    <!-- ESPECIE -->
    <div>
      <div class="w-full">
        <label class="flex grey-text text-xs my-2">{{ $t('especie') }}</label>
      </div>
      <div class="flex">
        <div class="w-full">
          <div class="w-full">
            <div class="md:flex chip infoChip mt-2 items-center">
              <label class="chipLabel truncate">{{ $t('nombreespecie') }}</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate">
                  <label class="truncate bold">{{specie.name}}</label>
                </div>
              </div>
            </div>
            <div class="md:flex chip infoChip mt-2 items-center">
              <label class="chipLabel truncate">{{ $t('nombrecientifico') }}</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate">
                  <label class="truncate cursiva">{{specie.scientificName}}</label>
                </div>
              </div>
            </div>
            <!-- <div class="md:flex chip infoChip mt-2 items-center">
              <label class="chipLabel truncate">CO2 contrarrestado/ año</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate">
                  <label class="truncate">{{specie.co2}} mmHg</label>
                </div>
              </div>
            </div>
            <div class="md:flex chip infoChip mt-2 items-center">
              <label class="chipLabel truncate">Crecimiento/ año</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate">
                   <label class="truncate">{{specie.height}} cm</label>
                </div>
              </div>
            </div> -->
            <div class="md:flex  chip infoChip mt-2 items-center mb-2">
              <label class="chipLabel truncate">{{ $t('estado') }}</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'es'">
                   <label class="truncate">{{specie.status }}</label>
                </div>
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'en'">
                   <label class="truncate">{{specie.status_us }}</label>
                </div>
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'de'">
                   <label class="truncate">{{specie.status_de }}</label>
                </div>
              </div>
            </div>
            <div class="md:flex chip infoChip mt-2 items-center mb-2">
              <label class="chipLabel truncate">{{ $t('elevacion') }}</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate">
                   <label class="truncate">{{specie.elevation}}</label>
                </div>
              </div>
            </div>
            <div class="md:flex chip infoChip mt-2 items-center mb-2">
              <label class="chipLabel truncate">{{ $t('region') }}</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'es'">
                   <label class="truncate">{{specie.region}}</label>
                </div>
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'en'">
                   <label class="truncate">{{specie.region_us}}</label>
                </div>
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'de'">
                   <label class="truncate">{{specie.region_de}}</label>
                </div>
              </div>
            </div>
            <div class="md:flex chip infoChip mt-2 items-center mb-2">
              <label class="chipLabel truncate">Habitat</label>
              <div class="flex-1 md:justify-end flex">
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'es'">
                   <label class="truncate">{{specie.habit}}</label>
                </div>
                <div class="flex justify-end truncate" v-if="$i18n.locale == 'en'">
                   <label class="truncate">{{specie.habit_us}}</label>
                </div>
                 <div class="flex justify-end truncate" v-if="$i18n.locale == 'de'">
                   <label class="truncate">{{specie.habit_de}}</label>
                </div>
              </div>
            </div>
            <!-- <div class="py-4 flex" v-if="specie.url">
              <div @click="openUrl(specie.url);" class="link items-center">
                <label>
                + Info
                </label>
              </div>
            </div>-->
          </div>
        </div>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'es'">
        <label class="block almost-black-text bold">{{ $t('descripcion') }}</label>
        <label class="block almost-black-text">{{specie.description}}</label>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'en'">
        <label class="block almost-black-text bold">{{ $t('descripcion') }}</label>
        <label class="block almost-black-text">{{specie.description_us}}</label>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'de'">
        <label class="block almost-black-text bold">{{ $t('descripcion') }}</label>
        <label class="block almost-black-text">{{specie.description_de}}</label>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'es'">
        <label class="block almost-black-text bold">{{ $t('criterioseleccion') }}</label>
        <label class="block almost-black-text">{{specie.selection}}</label>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'en'">
        <label class="block almost-black-text bold">{{ $t('criterioseleccion') }}</label>
        <label class="block almost-black-text">{{specie.selection_us}}</label>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'de'">
        <label class="block almost-black-text bold">{{ $t('criterioseleccion') }}</label>
        <label class="block almost-black-text">{{specie.selection_us}}</label>
      </div>
      <!-- <div class="w-full my-4">
        <label class="block almost-black-text bold">Uso</label>
        <label class="block almost-black-text">{{specie.use}}</label>
      </div> -->
    </div>
    <!-- RESERVA -->
    <div class="">
      <div class="w-full ">
        <label class="flex grey-text text-xs my-2">{{ $t('reserva') }}</label>
      </div>
       <div class="w-full my-4 md:flex" v-if="$i18n.locale == 'es'">
        <label class="block almost-black-text mr-4">{{reserve.description}}</label>
        <iframe class="ml-1 mt-2" width="240" height="135" :src="reserve.url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'en'">
         <label class="block almost-black-text">{{reserve.description_us}}</label>
      </div>
       <div class="w-full my-4" v-if="$i18n.locale == 'de'">
         <label class="block almost-black-text">{{reserve.description_de}}</label>
      </div>
    </div>

    <!-- ECOSISTEMA -->
    <div>
      <div class="w-full">
        <label class="flex grey-text text-xs my-2">{{ $t('ecosistema') }}</label>
      </div>
       <div class="w-full my-4" v-if="$i18n.locale == 'es'">
         <label class="block almost-black-text">{{ecosystem.description}}</label>
      </div>
      <div class="w-full my-4" v-if="$i18n.locale == 'en'">
         <label class="block almost-black-text">{{ecosystem.description_us}}</label>
      </div>
       <div class="w-full my-4" v-if="$i18n.locale == 'de'">
         <label class="block almost-black-text">{{ecosystem.description_de}}</label>
      </div>
    </div>

  </bvue-ui-view>
</template>

<script>
import {mapState} from 'vuex'
import AsideUser from '@/components/aside/AsideUser'
import { co2ofTree } from '@/utils/tree'
import PlantTree from '@/components/modals/PlantTree'
export default {
  name: 'Tree',
  components: {
    AsideUser
  },
  mounted() {
    this.$ga.page('/Informacion Arbol');
  },
  data () {
    return {
      reserveId: null,
      treeId: null
    }
  },
  computed: {
    ...mapState('auth', ['ready', 'user', 'profile']),
    reserve() {
      if (this.$store.state.reserves.items) {
        return this.$store.state.reserves.items[this.reserveId] || {}
      }
      return {}
    },
    tree() {
      if (this.reserve && this.reserve.trees) {
        return this.reserve.trees[this.treeId] || {position:{lat:0,lng:0}}
      }
      return {position:{lat:0,lng:0}}
    },
    planted() {
      if (this.reserve){
        for (const seedKey in this.reserve.seeds) {
          const planted = this.reserve.seeds[seedKey].planted
          if (planted && planted.treeId == this.treeId) {
            return planted
          }
        }
      }
      return null
    },
    owner() {
      if (this.planted && this.$store.state.profiles) {
        var response = this.$store.state.profiles[this.planted.ownerId]
        this.$store.dispatch('profiles/updateProfile', this.planted.ownerId)
        return response || {}
      }
      return null
    },
    ownerTrees() {
      if (this.owner) {
        return this.$store.getters.userTrees(this.owner.id) || {}
      }
      return 0
    },
    specie() {
      if (this.tree) {
        if (this.$store.state.species.items) {
          return this.$store.state.species.items[this.tree.specie] || {}
        }
      }
      return {}
    },
    ecosystem() {
      if (this.reserve && this.$store.state.ecosystems.items) {
        return this.$store.state.ecosystems.items[this.reserve.ecosystem] || {}
      }
      return {}
    },
    neutralizedCO2() {
      if (this.tree) {
        return co2ofTree(this.tree)
      }
      return 0
    }
  },
  methods: {
    avatar(profile) {
      return profile.image || require('@/assets/images/profile.svg')
    },
    formattedDate(timeStamp) {
      const date = new Date(timeStamp)
      return date.toLocaleDateString()
    },
    showOwnerProfile() {
      this.$router.push('/profile/'+this.owner.id)
    },
    plant() {
      if (!this.user) {
        this.$store.dispatch('auth/showSession', true)
      } else {
        this.$bvueUi.modal.show({
          component: PlantTree,
          width: 600,
          height: 500,
          data: {
            reserveId: this.reserveId,
            treeId: this.treeId,
            specie: this.specie
          }
        })
      }
    },
    openUrl(url) {
      window.open(url, '_blank')
    }
  },
  created() {
    const params = this.$route.params
    this.reserveId = params.reserveId
    this.treeId = params.treeId
    if (!this.reserveId || !this.treeId) {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';
$break-extra-small: 320px;
$break-small: 400px;
$break-large: 1200px;
.bvue-ui-view {
  @media screen and (min-width: $break-large) {
    padding: 1rem 2rem 2rem 2rem;
  }
}

.button-placeholder {
  margin: 20px 20px 20px 0px;
}
.cursiva {
  font-style: italic;
}
</style>




// WEBPACK FOOTER //
// src/pages/Tree.vue